<template>
    <div v-if="isLoggedIn" class="container page">

        <div>
            <sitecode-image src="topRecognition.jpg" class="img-fluid w-100" />
        </div>

        <section v-if="displayPart==0" class="card card-default">
            <div class="card-header">
                <h5>Pay It Forward</h5>
                <div><i>Points from Pay It Forward will be deducted from your Personal Profile.</i></div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-6"><strong>Selected Employees to Pay It Forward:</strong></div>
                    <div class="col-sm-6 text-right"></div>
                </div>
                <div v-for="r in selectedMems" :key="r._rowNum" class="row">
                    <template v-if="r.isEntireDivision">
                        <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                        <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                    </template>
                    <template v-else>
                        <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                        <div class="col">{{ r.firstname + ' ' + r.surname }} <span style="font-size:smaller">{{ r.memberNumber }}</span></div>
                        <div class="col">{{ r.division }}</div>
                    </template>
                </div>
                <div v-if="selectedMems.length===0" class="text-danger">Please select a recipient.</div>
                <div class="mt-1">
                    <b-button type="button" pill @click="$bvModal.show('modalChooseNominees')" variant="primary" size="sm" class="mt-2">{{selectedMems.length===0 ? 'Select' : 'Change'}}  Recipient</b-button>
                    <!--<a href="#" @click.prevent="$bvModal.show('modalChooseNominees')">Select Nominees</a>-->
                </div>

                <hr />
                <b-form @submit.prevent="onSubmitReward" novalidate>
                    <b-form-group id="groupReason" label-for="selectreason" label="Impact Behaviour:" :invalid-feedback="fReward.errors.reason" description="">
                        <b-form-select id="selectreason" v-model="fReward.form.reason" :state="fReward.state.reason">
                            <b-form-select-option :value="null">-- Please select a Behaviour --</b-form-select-option>       
                            <b-form-select-option value="Client Obsession">Client Obsession</b-form-select-option>
                            <b-form-select-option value="Unreasonable Excellence">Unreasonable Excellence</b-form-select-option>
                            <b-form-select-option value="Authentic Connections">Authentic Connections</b-form-select-option>
                            <b-form-select-option value="Act of Courage">Act of Courage</b-form-select-option>
                            <b-form-select-option value="Empowered Ownership">Empowered Ownership</b-form-select-option>
                            <b-form-select-option value="Collaborate for Success">Collaborate for Success</b-form-select-option>                            
                        </b-form-select>
                    </b-form-group>

                    <b-form-group id="groupPoints" label-for="points" label="Points Amount:" description="" :invalid-feedback="fReward.errors.points" :state="fReward.state.points">
                        <b-form-radio-group id="radiogroupPoints" v-model="fReward.form.points" name="points" :state="fReward.state.points">
                            <div class="row">
                                <div class="col-sm-3 col-lg-2 mb-2">
                                    <b-form-radio value="5">5 NexCredz</b-form-radio>
                                </div>
                                <div class="col-sm-3 col-lg-2 mb-2">
                                    <b-form-radio value="10">10 NexCredz</b-form-radio>
                                </div>
                                <div class="col-sm-3 col-lg-2 mb-2">
                                    <b-form-radio value="20">20 NexCredz</b-form-radio>
                                </div>
                                <div class="col-sm-3 col-lg-2 mb-2">
                                    <b-form-radio value="25">25 NexCredz</b-form-radio>
                                </div>
                                <div class="col-sm-3 col-lg-2 mb-2">
                                    <b-form-radio value="50">50 NexCredz</b-form-radio>
                                </div>
                                <div class="col-sm-3 col-lg-2 mb-2">
                                    <b-form-radio value="100">100 NexCredz</b-form-radio>
                                </div>
                                <!--<div class="col-sm-3 col-lg-2 mb-2">
                            <b-form-radio value="150">150 NexCredz</b-form-radio>
                        </div>
                        <div class="col-sm-3 col-lg-2 mb-2">
                            <b-form-radio value="200">200 NexCredz</b-form-radio>
                        </div>
                        <div class="col-sm-3 col-lg-2 mb-2">
                            <b-form-radio value="250">250 NexCredz</b-form-radio>
                        </div>
                        <div class="col-sm-3 col-lg-2 mb-2">
                            <b-form-radio value="500">500 NexCredz</b-form-radio>
                        </div>
                        <div class="col-sm-3 col-lg-2 mb-2">
                            <b-form-radio value="1000">1000 NexCredz</b-form-radio>
                        </div>
                        <div class="col-sm-3 col-lg-2 mb-2">
                            <b-form-radio value="2000">2000 NexCredz</b-form-radio>
                        </div>
                        <div class="col-sm-3 col-lg-2 mb-2">
                            <b-form-radio value="5000">5000 NexCredz</b-form-radio>
                        </div>-->
                            </div>
                        </b-form-radio-group>
                    </b-form-group>
                    <!--
            <b-form-group id="groupSendBy" label-for="sendBy" description="" :invalid-feedback="fReward.errors.sendBy" :state="fReward.state.sendBy" class="mt-4">
                <b-form-radio-group id="radiogroupSendBy" v-model="fReward.form.sendBy" name="sendBy" :state="fReward.state.sendBy">
                    <div class="row">
                        <div class="col-sm-3 col-lg-2">
                            <b-form-radio value="email">Email</b-form-radio>
                        </div>
                        <div class="col-sm-3 col-lg-2">
                            <b-form-radio value="sms">SMS</b-form-radio>
                        </div>
            </div>
            </b-form-radio-group>
            </b-form-group>
            -->
            <b-form-group id="groupRewardMessage" label-for="txtRewardMessage" label="Message to Recipients" :invalid-feedback="fReward.errors.message" :description="(isSendBySMS?150:350)-fReward.form.message.length + ' characters remaining'">
                <b-form-textarea id="txtRewardMessage" :disabled="fReward.form.sendBy===null" v-model="fReward.form.message" :state="fReward.state.message" :placeholder="isSendBySMS ? 'Short SMS message to recipients up to 150 characters' : 'Short email message to recipients up to 350 characters'" rows="3" max-rows="5" :maxlength="(isSendBySMS?150:350)" />
            </b-form-group>

            <hr />

            <div class="text-right"><b-button type="submit" variant="primary">Submit</b-button></div>
            </b-form>
</div>
        </section>

        <section v-if="displayPart==1" class="card card-default">
            <div class="card-header">
                <h5>Pay It Forward</h5>
                <div><i>Points from Pay It Forward will be deducted from your Personal Profile.</i></div>
            </div>
            <div class="card-body">
                <b-alert variant="success" show>
                    <h4 class="alert-heading">Pay It Forward</h4>
                    <p>
                        Successfully submitted Pay It Forward.
                    </p>
                </b-alert>
            </div>
            <div class="card-footer">
                <div class="text-right"><button type="button" @click="displayPart=0" class="btn btn-primary">Send Another</button></div>
            </div>

        </section>



        <!--
    **************************************************************************************************************************************************
                                                                M O D A L S
    **************************************************************************************************************************************************
    -->
        <!-- Modal - Nominees -->
        <b-modal id="modalChooseNominees" title="Pay It Forward" hide-footer size="xl" no-close-on-backdrop>
            <member-select title="Select recipients"
                           selectedTitle="Recipients"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedMems"
                           :isAllowWholeDivision="false"
                           :isSingle="false"
                           :showContinue="false"
                           class="mb-3" />

            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominees')">Done</b-button></div>
        </b-modal>

    </div>

</template>

<script>
    // @ is an alias to /src
    import SitecodeImage from '@/components/SitecodeImage';
    import axios from 'axios'
    //import sjData from '@/sjUtilData'
    import MemberSelect from '@/components/MemberSelect';


    export default {
        name: 'Reward',
        components: {
            MemberSelect,
			'sitecode-image': SitecodeImage},
        data() {
            return {
                displayPart: 0,

                fReward: {
					form: { what:'payitforward', reason: null, points: null, message: '', sendBy: 'sms', recipients: [] }
                },

                selectedMems: [],

                roles: { ca: false, cc: false, idea: false, inv: false },

                reportTitle: '',

            }
        },
        computed: {
            isLoggedIn() {
                return this.$store.state.isLoggedIn
            },
            countryList() {
                if (this.isCountryFixed) { //only show the default cluster.
                    return this.$store.state.countryList.filter(country => country.countryCode === this.defaultCountryCode);
                } else {
                    return [{ countryCode: null, country: '-- Please select a Cluster--', disabled: true }]
                        .concat(this.$store.state.countryList);
                }
            },
            memberClusterCode() {
                return this.$store.state.memberStore.member.clusterCode
            },
            memberDivisionCode() {
                return this.$store.state.memberStore.member.divisionCode
            },
            isSendBySMS() {
                return this.fReward.form.sendBy === 'sms';
			}
        },
        created() {
            //formSetState must be called on creation, to ensure all fields are setup
            this.formSetState(this.fReward, true, true) //formObj, resetState, resetForm

            this.preSelectMemberLinkIn();

            this.$store
                .dispatch('getDivisionList', {})
                .then(() => {
                    this.displayPart = 0;

                })
                .catch((error) => {
                    this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occurred: ' + JSON.stringify(error)));
                });


        },
        mounted() {

        },
        methods: {

            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            },

            //*** formStatusUpdate - used to display form errors.
            //Ensure this.form contains the list of fields.
            //Call  formStatusUpdate(true) to initialise/clear the form errors.
            //formObject is the object that contains the following objects:  .form, .formState, .formErrors
            formSetState(formObj, resetState, resetForm) {
                if (typeof resetState === 'undefined') resetState = false;
                if (typeof resetForm === 'undefined') resetForm = false;
                if (typeof formObj.init === 'undefined') formObj.init = { ...formObj.form }; //Initialise .formInit object to be a copy of .form object.
                if (typeof formObj.errors === 'undefined') this.$set(formObj, 'errors', {}); //use this.$set  to make errors object reactive
                if (typeof formObj.state === 'undefined') this.$set(formObj, 'state', {});   //use this.$set  to make state object reactive

                if (resetState || resetForm) {
                    if (resetForm) formObj.form = { ...formObj.init }; //copy .init to .form

                    formObj.errors = {}; //reset formErrors object
                    formObj.state = {};
                }

                //update formState
                var fields = Object.getOwnPropertyNames(formObj.form);
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i];
                    if (resetState) {
                        formObj.state[field] = null;
                    } else if (typeof formObj.errors[field] === 'undefined' || formObj.errors[field] === '') {
                        formObj.state[field] = true;
                    } else {
                        formObj.state[field] = false;
                    }
                }
            },

			preSelectMemberLinkIn() {
				//Add member to selected list, if passed in on sessionStorage (tloid)
				let tloidMemberId = sessionStorage.getItem('tloid'); //tloid - temp link out id - i.e. MemberId
				if (tloidMemberId) {
					sessionStorage.removeItem('tloid');
					axios.post('/api/site/getmemberget', { memberId: tloidMemberId })
						.then(({ data }) => {
							this.selectedMems.push({
								_serialNo: -1,
								division: data.companyName,
								firstname: data.firstName,
								surname: data.surname,
								isManager: false,
								memberId: data.memberId,
								memberNumber: data.memberNumber,
								isEntireDivision: false,
								entireDivisionCode: ''
							});
						})
						.catch((error) => {
							if (error) {
								this.msgBox('Error retrieving member data');
							}
						})
                }


				let tlowhat = sessionStorage.getItem('tlowhat'); //tloid - temp link out id - i.e. MemberId
                if (tlowhat) {
					sessionStorage.removeItem('tlowhat');

                    if (tlowhat == "BDAY") {
                        this.fReward.form.reason = 'Happy Birthday';
                    } else if (tlowhat == "ANNIV") {
						this.fReward.form.reason = 'Happy Work Anniversary';
                    }
				}
			},



            onSubmitReward() {
                this.formSetState(this.fReward, true);//formObj, resetState, resetForm
				this.fReward.form.recipients = this.selectedMems.map(item => item.isEntireDivision ? 'div:' + item.entireDivisionCode : item.memberId);
				if (this.selectedMems.length === 0) {
					this.msgBox('Please select at least one recipient.','Recipients required');
					return;
				} 

                //this.displayPart = 1;
                if (this.displayPart == 0) {
                    return axios
                        .post(
                            '/api/reward/doreward',
                            this.fReward.form
                        )
                        .then(({ data }) => {
                            console.log(data);
                            this.displayPart = 1;
							this.selectedMems = [];
                            this.formSetState(this.fReward, true, true);
							this.$store.dispatch('memberStore/getMemberData');
                        })
                        .catch((error) => {
                            this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occurred: ' + JSON.stringify(error.response.data)));
                            if (error.response.data.formErrors) {
                                this.fReward.errors = error.response.data.formErrors;
                                this.formSetState(this.fReward);
                            }
                        })
                        ;
                }
            },

        }




    }
</script>
